import React, { useMemo } from "react";
import { FormProvider } from "react-hook-form";

import scopedControls from "components/form/ScopedNunitoFormControls.module.css";
import { Button } from "components/ui/Button/Button";
import { useDoctors } from "features/practice/hooks/useDoctors";
import { onInvalidSubmit } from "utils/reportFormErrors";

import { PatientProfileAddressSection } from "./components/PatientProfileAddressSection";
import { PatientProfileClassificationGpSection } from "./components/PatientProfileClassificationGpSection";
import { PatientProfileContactSection } from "./components/PatientProfileContactSection";
import { PatientProfilePersonalSection } from "./components/PatientProfilePersonalSection";
import { usePatientProfileForm } from "./hooks/usePatientProfileForm";
import styles from "./PatientProfileForm.module.css";
import { mapDoctorsToSelectOptions } from "./utils/patientProfileFormDefaults";

export function PatientProfileForm({
  patient,
  doctors,
  onSubmit,
  hideSubmitButton,
  formId,
}) {
  const mode = patient != null ? "edit" : "create";

  const {
    form,
    isCreate,
    ethnicGroups,
    nextOfKinRelationshipSelectOptions,
    handleFormSubmit,
  } = usePatientProfileForm({ mode, patient, onSubmit });

  const { data: doctorsRaw } = useDoctors();
  const doctorSelectOptions = useMemo(
    () => doctors ?? mapDoctorsToSelectOptions(doctorsRaw),
    [doctors, doctorsRaw]
  );

  return (
    <FormProvider {...form}>
      <form
        id={formId}
        className={`${scopedControls.scope} ${styles.form}`}
        onSubmit={form.handleSubmit(handleFormSubmit, onInvalidSubmit("PatientProfileForm"))}
        noValidate
      >
        <PatientProfilePersonalSection
          isCreate={isCreate}
          ethnicGroups={ethnicGroups}
        />
        <PatientProfileContactSection
          isCreate={isCreate}
          nextOfKinRelationshipSelectOptions={
            nextOfKinRelationshipSelectOptions
          }
        />
        <PatientProfileAddressSection isCreate={isCreate} />
        <PatientProfileClassificationGpSection
          isCreate={isCreate}
          doctors={doctorSelectOptions}
          primaryGpContact={patient?.primaryGp}
        />
        {!hideSubmitButton && (
          <div className={styles.actions}>
            <Button type="submit" variant="primary">
              Save
            </Button>
          </div>
        )}
      </form>
    </FormProvider>
  );
}
